export default {
  state    : {
    currentUser: null
  },
  mutations: {
    SET_CURRENT_USER(state, user) {
      console.log("Inside SET_CURRENT_USER", user);
      console.trace()
      // Object.assign({}, null) turned a logout (null) into a truthy {} user,
      // which isLoggedNonAnonymously then treated as "logged in" — keep null as null.
      state.currentUser = user ? Object.assign({}, user) : null;
    },
  },
  actions  : {},
  getters  : {
    GET_CURRENT_USER: (state) => {
      return state.currentUser;
    }
  },
}
